"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    tooltipBackground: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        visibility: 'hidden'
    },
    tooltipArrowWrapper: {
        visibility: 'hidden',
        position: 'absolute',
        zIndex: 7,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    tooltipContainer: {
        visibility: 'hidden',
        position: 'absolute',
        overflowY: 'auto',
        zIndex: 7
    }
};
//# sourceMappingURL=tooltip.style.js.map